// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1oG2z","question":"Question_question__2q1Y2","description":"Question_description__3cSGC"};